import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreateRoleRequest,
  CreateRolesResponse,
  ListBuRolesRequest,
  ListRolesRequest,
  ListRolesResponse,
  Role,
  UpdateRoleRequest,
  UpdateRolesResponse,
} from 'src/types/orbit/Roles';

export const roleService = {
  // Get all roles
  getAllRolesbyBusinessUnit: (data: ListBuRolesRequest) => {
    return apiClient.get<ListRolesResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.ROLE.ALL_BY_BUSINESS_UNIT(
          data.programId,
          data.businessUnitId,
        ),
      ),
      data,
    );
  },

  getAllDefaultRoles: (data: ListRolesRequest) => {
    return apiClient.get<ListRolesResponse>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.ROLE.ALL_DEFAULT(data.programId)),
      data,
    );
  },

  // Update user
  update: (programId: string, data: UpdateRoleRequest) => {
    return apiClient.put<UpdateRolesResponse, UpdateRoleRequest>(
      ServiceType.ORBIT,
      createApiUrl(API_ENDPOINTS.ORBIT_SERVERICE.ROLE.UPDATE(programId, data.roleId)),
      data,
    );
  },

  updateBusinessUnitRole: (
    programId: string,
    businessUnitId: string,
    data: UpdateRoleRequest,
  ) => {
    return apiClient.put<UpdateRolesResponse, UpdateRoleRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.ROLE.UPDATE_BUSINESS_UNIT_ROLE(
          programId,
          businessUnitId,
          data.roleId,
        ),
      ),
      data,
    );
  },
};
